import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import React, { useEffect, useState } from "react";

const META = [
  {
    url: "/",
    title:
      "Fífa Kerhart - legendární doučování (NEJEN) pro VŠE | Videonalejvárny.cz od Fífy",
    description:
      "Legenda doučování na VŠE. Jestli nechceš dopadnout u testů a zkoušek jako rozpočet po Babišovi, svěř se do mý péče.",
  },
  {
    url: "/o-fifovi",
    title: "Doučování s Fífou Kerhartem | Videonalejvárny.cz od Fífy",
    description:
      "Legenda doučování na VŠE. Jestli nechceš dopadnout u testů a zkoušek jako rozpočet po Babišovi, svěř se do mý péče.",
  },
  {
    url: "/recenze",
    title: "Recenze na Fífu | Videonalejvárny.cz od Fífy",
    description:
      "Ti, kdo to přežili, se s vámi podělí o dojmy z mýho doučování. A že jich nebylo málo.",
  },
  {
    url: "/faq",
    title: "Na co se Fífy ptáte | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kreditovy-system",
    title: "Doporuč na získej  | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/doporuc-a-ziskej",
    title: "Doporuč na získej  | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/vysoka-skola",
    title: "Fífa tě doučí předměty (NEJEN) pro VŠE | Videonalejvárny.cz",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/stredni-skola",
    title: "Doučování s Fífou Kerhartem | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/analyticka-geometrie",
    title: "Doučování: Analytická Geometrie | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/ekonomie-i",
    title: "Doučování: Ekonomie - 3MI101/3MI191 | Videonalejvárny.cz od Fífy",
    description:
      "Eko od Fífy, nejlepší Eko! Makro i mikro ti vysvětlím, líp než když Babiš vysvětluje zdroje svých příjmů. ",
  },
  {
    url: "/kategorie/ekonomie-ii",
    title: "Doučování: Ekonomie II - 3MI411 | Videonalejvárny.cz od Fífy",
    description:
      "Řešená cvičebnice, příprava na testy. Scénař: Fífa. Režie: Fífa. Tvoje skóre u závěrečnýho testu: 100 %. ",
  },
  {
    url: "/kategorie/finance-podniku",
    title: "Doučování: Finance Podniku | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/financni-analyza",
    title: "Doučování: Finanční Analýza | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/funkce",
    title: "Doučování: Funkce | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/goniometrie",
    title: "Doučování: Goniometrie | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/ifrs",
    title: "Doučování: IFRS | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/kombinatorika-a-pravdepodobnost",
    title:
      "Doučování: Kombinatorika a Pravděpodobnost | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/komplexni-cisla",
    title: "Doučování: Komplexní Čísla | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/makroekonomie-ii",
    title:
      "Doučování: Makroekonomie II - 3MI404/3MI408/5EN205 | Videonalejvárny.cz od Fífy",
    description:
      "Komplet příprava na testy i ústní z makra. Projdeš jako pivo hrdlem v pátek večer – bez zaváhání a s radostí. 🍻",
  },
  {
    url: "/kategorie/manazerska-ekonomika",
    title: "Doučování: Manažerská Ekonomika | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/manazerske-ucetnictvi-i",
    title: "Doučování: Manažerské Účetnictví I | Videonalejvárny.cz od Fífy",
    description:
      "Doučím tě komplet manažerko a připravím tě i na závěrečnej test, kterým projdeš jako pivo hrdlem v pátek večer – bez zaváhání a s radostí. 🍻",
  },
  {
    url: "/kategorie/manazerske-ucetnictvi-ii",
    title: "Doučování: Manažerské Účetnictví II | Videonalejvárny.cz od Fífy",
    description:
      "Naleju ti do hlavy komplet manažerko a vyšlu tě na závěrečnej test, kterým proletíš jak první pivo po těžkým týdnu – hladce, rychle a s úlevou. 🍻",
  },
  {
    url: "/kategorie/matematika",
    title: "Doučování: Matematika | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/matematika-i",
    title: "Doučování: Matematika I | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/mezinarodni-ekonomie-i",
    title: "Doučování: Mezinárodní Ekonomie I | Videonalejvárny.cz od Fífy",
    description: "Mezeko příprava na testy od legendy z VŠE. ",
  },
  {
    url: "/kategorie/mezinarodni-ekonomie-ii",
    title:
      "Doučování: Mezinárodní Ekonomie II - 2SE420/2SE445 | Videonalejvárny.cz od Fífy",
    description: "Mezeko příprava na testy od legendy z VŠE. ",
  },
  {
    url: "/kategorie/mezinarodni-vobchodni-voperace",
    title:
      "Doučování: Mezinárodní Obchodní Operace | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/mikroekonomie-ii",
    title:
      "Doučování: Mikroekonomie II - 3MI403/3MI407/3MI411 | Videonalejvárny.cz od Fífy",
    description:
      "Teorie, vypočtený testy, příprava na ústní. To dáš a ještě mi poděkuješ ❤️. ",
  },
  {
    url: "/kategorie/mocniny-a-odmocniny",
    title: "Doučování: Mocniny a Odmocniny | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/nerovnice-a-jejich-soustavy",
    title:
      "Doučování: Nerovnice a Jejich Soustavy | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/ocenovani-podniku-i",
    title: "Doučování: Ocenění Podniků I | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/ocenovani-podniku-ii",
    title: "Doučování: Ocenění Podniků II | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/planimetrie",
    title: "Doučování: Planimetrie | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/posloupnosti",
    title: "Doučování: Posloupnosti | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/rovnice-a-jejich-soustavy",
    title: "Doučování: Rovnice a Jejich Soustavy | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/statistika",
    title: "Doučování: Statistika | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/statistika-1",
    title: "Doučování: Statistika 1 | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/stereometrie",
    title: "Doučování: Stereometrie | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/ucetnictvi-i",
    title:
      "Doučování: Účetnictví I - 1FU201/1FU211 | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/ucetnictvi-ii",
    title: "Doučování: Účetnictví II - 1FU202 | Videonalejvárny.cz od Fífy",
    description:
      "Připravím tě na průběžný i závěrečný testy jako když v hospodě zahlídneš poslední pivo na čepu – bez váhání a na jistotu. 🍻",
  },
  {
    url: "/kategorie/ucetnictvi-statni-spravy",
    title:
      "Doučování: Účetnictví Státní Správy - 1FU304/1FU233| Videonalejvárny.cz od Fífy",
    description:
      "Ukážu ti jak spočítat cvičebnici a připravím tě na test, že ho napíšeš i se dvěma promilema. ",
  },
  {
    url: "/kategorie/vyrazy",
    title: "Doučování: Výrazy | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kategorie/zakladni-poznatky",
    title:
      "Fífa Kerhart - legendární doučování (NEJEN) pro VŠE | Videonalejvárny.cz od Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/casova-hodnota-penez",
    title: "Doučování: Časová hodnota peněz | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/casove-rozliseni-a-zasoby",
    title: "Doučování: Časové rozlišení a zásoby | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/ctyruhelniky",
    title: "Doučování: Čtyřúhelníky | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/dalsi-objekty-v-rovine",
    title: "Doučování: Další objekty v rovině | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/dalsi-operace-s-vektory",
    title: "Doučování: Další operace s vektory | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/dalsi-typy-nerovnic-i",
    title: "Doučování: Další typy nerovnic I. | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/dalsi-typy-nerovnic-ii",
    title: "Doučování: Nerovnice vyšších mocnin | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/dalsi-typy-rovnic-1",
    title:
      "Doučování: Rovnice v součinovém a podílovém tvaru | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/dane",
    title: "Doučování: Daně | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/dane-a-cash-flow",
    title: "Doučování: Daně a cash flow | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/dk-trh-prace",
    title: "Doučování: DK trh práce | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/dlouhodoby-majetek",
    title: "Doučování: Dlouhodobý majetek | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/dluhopisy-a-akcie",
    title: "Doučování: Dluhopisy a akcie | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/dokonala-konkurence-1",
    title: "Doučování: Dokonalá konkurence | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/elipsa-kuzelosecka",
    title: "Doučování: Elipsa (kuželosečka) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/exponencialni-funkce",
    title: "Doučování: Exponenciální funkce | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/exponencialni-nerovnice",
    title: "Doučování: Exponenciální nerovnice | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/exponencialni-rovnice",
    title: "Doučování: Exponenciální rovnice | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/financni-analyza",
    title: "Doučování: Finanční analýza | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/financni-majetek-akcie-a-dluhopisy",
    title:
      "Doučování: Příprava na 2.PT (finanční majetek) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/financni-management-a-investice",
    title:
      "Doučování: Finanční management a investice | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/hodnotova-kriteria",
    title: "Doučování: Hodnotová kritéria | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/hyperbola-kuzelosecka",
    title:
      "Doučování: Hyperbola (kuželosečka) - Brzo! | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/interni-vh-a-rozpocty",
    title: "Doučování: Interní VH a rozpočty | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/iracionalni-rovnice",
    title: "Doučování: Iracionální rovnice | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/kalkulace-jednicovych-nakladu",
    title:
      "Doučování: Kalkulace jednicových nákladů | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/kalkulace-rezijnich-nakladu-a-alokace",
    title:
      "Doučování: Kalkulace režijních nákladů a alokace | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/kruznice-a-kruh",
    title: "Doučování: Kružnice a kruh | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/kruznice-kuzelosecky",
    title: "Doučování: Kružnice (kuželosečka) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/kvadraticka-funkce-1",
    title: "Doučování: Kvadratická funkce | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/kvadraticke-rovnice-1",
    title: "Doučování: Kvadratické rovnice | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/kvadraticke-rovnice-ii-cast",
    title:
      "Doučování: Kvadratické rovnice II. část | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/linearni-funkce",
    title: "Doučování: Lineární funkce | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/linearni-lomena-funkce-1",
    title: "Doučování: Lineární lomená funkce | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/linearni-nerovnice",
    title: "Doučování: Lineární nerovnice | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/linearni-rovnice",
    title: "Doučování: Lineární rovnice | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/logaritmicka-funkce",
    title: "Doučování: Logaritmická funkce | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/logaritmicke-nerovnice",
    title: "Doučování: Logaritmické nerovnice | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/logaritmicke-rovnice",
    title: "Doučování: Logaritmické rovnice | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/lomene-vyrazy",
    title: "Doučování: Lomené výrazy | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/makroekonomie-nekomplet",
    title: "Doučování: Makroekonomie NEkomplet | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/manualni-prevodovka",
    title: "Doučování: Manuální převodovka | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/matematika-komplet",
    title: "Doučování: Matematika komplet | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/mezeko-i-priprava-na-testy",
    title:
      "Doučování: Mezeko I. - příprava na testy | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/mikroekonomie-komplet",
    title: "Doučování: Mikroekonomie komplet | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/mnohocleny-1",
    title: "Doučování: Mnohočleny | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/mnohouhelniky",
    title: "Doučování: Mnohoúhelníky | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/mocninna-funkce-1",
    title: "Doučování: Mocninná funkce | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/mocniny-a-odmocniny",
    title: "Doučování: Mocniny a odmocniny | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/monopol-a-cenova-diskriminace-1",
    title:
      "Doučování: Monopol a cenová diskriminace | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/monopolisticka-konkurence-1",
    title: "Doučování: Monopolistická konkurence | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/nabidka-prace",
    title: "Doučování: Nabídka práce | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/ndk-trh-prace",
    title: "Doučování: NDK trh práce | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/nerovnice-s-absolutni-hodnotou",
    title:
      "Doučování: Nerovnice s absolutní hodnotou | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/odchylky",
    title: "Doučování: Odchylky | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/odmocnina-jako-funkce-1",
    title: "Doučování: Odmocnina jako funkce | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/oligopol-1",
    title: "Doučování: Oligopol | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/opravne-polozky-a-rezervy",
    title: "Doučování: Opravné položky a rezervy | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/parabola-kuzelosecka",
    title: "Doučování: Parabola (kuželosečka) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/pf-a-naklady-v-do",
    title: "Doučování: PF a náklady v DO | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/pf-a-naklady-v-ko",
    title: "Doučování: PF a náklady v KO | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/pocitani-s-lomenymi-vyrazy",
    title: "Doučování: Počítání s lomenými výrazy | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/pocitani-s-vektory",
    title: "Doučování: Počítání s vektory | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/poptavka-1",
    title: "Doučování: Poptávka | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/prijmy-a-zisk-firmy",
    title: "Doučování: Příjmy a zisk firmy | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/primka-a-rovina-v-prostoru",
    title: "Doučování: Přímka a rovina v prostoru | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/primka-v-rovine-i",
    title: "Doučování: Přímka v rovině I. | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/primka-v-rovine-ii",
    title: "Doučování: Přímka v rovině II. | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/primka-v-rovine-iii",
    title: "Doučování: Přímka v rovině III. | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/pripadova-studie-abstinent",
    title: "Doučování: Případová studie ABSTINENT | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/pripadova-studie-beta",
    title: "Doučování: Případová studie BETA | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/pripadova-studie-botex",
    title: "Doučování: Případová studie BOTEX | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/pripadova-studie-eximet",
    title: "Doučování: Případová studie EXIMET | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-1-pt",
    title: "Doučování: Příprava na 1.PT | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-1-pt-dlouhodoby-majetek",
    title:
      "Doučování: Příprava na 1.PT (dlouhodobý majetek) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-1-pt-z-3mi411",
    title: "Doučování: Příprava na 1.PT z 3MI411 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-1-pt-z-6mmae1",
    title: "Doučování: Příprava na 1.PT z 6MMAE1 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-1-pt-z-fp",
    title: "Doučování: Příprava na 1.PT z FP | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-1-pt-z-ifrs",
    title: "Doučování: Příprava na 1.PT z IFRS | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-2-pt-z-3mi411",
    title: "Doučování: Příprava na 2.PT z 3MI411 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-2-pt-z-6mmae1",
    title: "Doučování: Příprava na 2.PT z 6MMAE1 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-2-pt-z-fp",
    title: "Doučování: Příprava na 2.PT z FP | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-3-pt-z-6mmae1",
    title: "Doučování: Příprava na 3.PT z 6MMAE1 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-4-pt-z-6mmae1",
    title: "Doučování: Příprava na 4.PT z 6MMAE1 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-5-pt-z-6mmae1",
    title: "Doučování: Příprava na 5.PT z 6MMAE1 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-pt-z-1fu304-1fu233",
    title:
      "Doučování: Příprava na PT z 1FU304/1FU233 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-szz-mezeko",
    title:
      "Doučování: Příprava na test a SZZ 3. část (Mezeko II) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-test-a-szz-1-cast-mezeko-ii",
    title:
      "Doučování: Příprava na test a SZZ 1. část (Mezeko II) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-test-a-szz-2-cast-mezeko-ii",
    title:
      "Doučování: Příprava na test a SZZ 2. část (Mezeko II) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-test-a-szz-4-cast-mezeko-ii",
    title:
      "Doučování: Příprava na test a SZZ 4. část (Mezeko II) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-ustni-szz-1",
    title: "Doučování: Příprava na ústní/SZZ | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-ustni-szz-makro-update",
    title:
      "Doučování: Příprava na ústní/SZZ (Makro II.) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-zt-komplet",
    title: "Doučování: Příprava na ZT z 1FU202 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-zt-z-1fu201-1fu211",
    title:
      "Doučování: Příprava na ZT z 1FU201/1FU211 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-zt-z-2op816",
    title: "Doučování: Příprava na ZT z 2OP816 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-zt-z-3mi411",
    title: "Doučování: Příprava na ZT z 3MI411 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-zt-z-ocepa-i",
    title: "Doučování: Příprava na ZT z ocepa I. | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/priprava-na-zt-z-ocepa-ii",
    title: "Doučování: Příprava na ZT z ocepa II. | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/resena-cvicebnice",
    title: "Doučování: Řešená cvičebnice | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/resena-cvicebnice-z-1fu304-1fu233",
    title:
      "Doučování: Řešená cvičebnice z 1FU304/1FU233 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/resena-cvicebnice-z-6mmae1",
    title: "Doučování: Řešená cvičebnice z 6MMAE1 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/resena-cviceni-z-ifrs-1-cast",
    title:
      "Doučování: Řešená cvičení z IFRS 1. část | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/resena-cviceni-z-ifrs-2-cast",
    title:
      "Doučování: Řešená cvičení z IFRS 2. část | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/resena-cviceni-z-mae-3mi411",
    title:
      "Doučování: Řešená cvičení z MAE (3MI411) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/resena-cviceni-z-mie-3mi411",
    title:
      "Doučování: Řešená cvičení z MIE (3MI411) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/resena-skolni-sbirka-1fu202-1-cast",
    title:
      "Doučování: Řešená školní sbírka 1FU202 (1. část) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/resena-skolni-sbirka-1fu202-2-cast",
    title:
      "Doučování: Řešená školní sbírka 1FU202 (2. část) | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/reseni-doplnkovych-ukolu-z-3mi411",
    title:
      "Doučování: Řešení doplňkových úkolů z 3MI411 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/riziko-1",
    title: "Doučování: Riziko | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/riziko-2",
    title: "Doučování: Riziko | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/rovnice-vyssich-mocnin",
    title: "Doučování: Rovnice vyšších mocnin | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/rozklad-na-soucin-1",
    title: "Doučování: Rozklad na součin I. | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/rozklad-na-soucin-ii",
    title: "Doučování: Rozklad na součin II. | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/soustavy-3-rovnic",
    title: "Doučování: Soustavy 3 rovnic | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/soustavy-linearnich-nerovnic",
    title:
      "Doučování: Soustavy lineárních nerovnic | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/soustavy-linearnich-rovnic",
    title: "Doučování: Soustavy 2 rovnic | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/spotrebitel-1",
    title: "Doučování: Spotřebitel | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/statistika-vse-1-cast",
    title: "Doučování: Statistika VŠE 1. část | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/statistika-vse-2-cast",
    title: "Doučování: Statistika VŠE 2. část | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/statistika-vse-3-cast",
    title: "Doučování: Statistika VŠE 3. část | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/teorie-her",
    title: "Doučování: Teorie her | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/teorie-k-1fu202",
    title:
      "Doučování: Účetnictví II. - teorie k ZT | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/teorie-na-1-pt-z-1mu666",
    title: "Doučování: Teorie na 1.PT z 1FP666 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/teorie-na-1-pt-z-3mi404",
    title: "Doučování: Teorie na 1.PT z 3MI404 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/teorie-na-1-pt-z-3mi404-1",
    title: "Doučování: Teorie na 2.PT z 3MI404 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/teorie-na-1-pt-z-3mi408",
    title: "Doučování: Teorie na 1.PT z 3MI408 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/teorie-na-2-pt-z-1fp666",
    title: "Doučování: Teorie na 2.PT z 1FP666 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/teorie-na-2-pt-z-3mi408",
    title: "Doučování: Teorie na 2.PT z 3MI408 | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/trh-kapitalu",
    title: "Doučování: Trh kapitálu | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/trojuhelnik",
    title: "Doučování: Trojúhelník | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/trzni-selhani-a-mie-politika-statu",
    title:
      "Doučování: Tržní selhání a MIE politika státu | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/tvorba-cen-u-vice-statku",
    title: "Doučování: Tvorba cen u více statků | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/ucelove-a-druhove-cleneni",
    title: "Doučování: Účelové a druhové členění | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/ucetnictvi-i-teorie-k-zt",
    title:
      "Doučování: Účetnictví I. - teorie k ZT | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/uvod-bod-usecka",
    title: "Doučování: Úvod, bod, úsečka | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/uvod-do-funkci",
    title: "Doučování: Úvod do funkcí | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/uvod-do-mikroekonomie",
    title: "Doučování: Úvod k mikru | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/uvod-do-planimetrie",
    title: "Doučování: Úvod do planimetrie | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/variabilni-a-fixni-naklady",
    title: "Doučování: Variabilní a fixní náklady | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/vektor-co-je-to",
    title: "Doučování: Vektor - co je to | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/vlastni-kapital-akcie-a-dluhopisy",
    title:
      "Doučování: Vlastní kapitál, akcie a dluhopisy | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/vseobecna-rovnovaha",
    title: "Doučování: Všeobecná rovnováha | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/vysledovky-cast-1",
    title: "Doučování: Výsledovky - část 1. | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/vysledovky-cast-2",
    title: "Doučování: Výsledovky - část 2. | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/vzajemna-poloha-primek-a-rovin",
    title:
      "Doučování: Vzájemná poloha přímek a rovin | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/vzorove-testy-z-mie-me",
    title: "Doučování: Vzorové testy z MIE/ME | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
  {
    url: "/kurz/zaverecne-testy-z-mu",
    title: "Doučování: Závěrečné testy z MÚ | Videonalejvárny.cz of Fífy",
    description:
      "Vysvětlím ti to jednoduše líp, než Babiš na tiskovce. Jsem Fífa. Legenda doučování (nejen) účetnictví (nejen) pro VŠE. ",
  },
];

const Meta = () => {
  const location = useLocation();

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const idx = META.findIndex((m) => {
      return m.url === location.pathname;
    });
    if (idx > -1) {
      setIndex(idx);
    } else {
      setIndex(0);
    }
  }, [location.pathname]);

  return (
    <Helmet>
      <title>{META[index].title}</title>
      <meta name="description" content={META[index].description} />
      <link rel="canonical" href={window.location.href} />
      <meta name="robots" content="index, follow" />
    </Helmet>
  );
};

export default Meta;
